import { orderHistoryRoutes } from "./MyOrders/MyOrders.router";
import { paymentHostoryRoutes } from "./PaymentHistory/PaymentHistory.router";


export const userViewRoutes = [
    ...paymentHostoryRoutes,
    ...orderHistoryRoutes
]